<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />
      <div class="card">
        <div class="title">Laporan Akumulasi Penjualan Harian</div>
        <DataTable
          :value="items"
          :paginator="true"
          :loading="loading"
          class="p-datatable-outlets"
          :rows="30"
          :rowHover="true"
          :scrollable="true"
          scrollDirection="horizontal"
        >
          <template #header>
            <div class="p-grid p-fluid p-mb-2">
              <div class="p-col" style="margin-top: 2.2rem">
                <Calendar
                  v-model="start_date"
                  :showIcon="true"
                  dateFormat="yy-mm-dd"
                  placeholder="Start Date"
                  :selectOtherMonths="true"
                  :showButtonBar="true"
                />
              </div>
              <div class="p-col" style="margin-top: 2.2rem">
                <Calendar
                  v-model="end_date"
                  :showIcon="true"
                  dateFormat="yy-mm-dd"
                  placeholder="End Date"
                  :selectOtherMonths="true"
                  :showButtonBar="true"
                />
              </div>

              <div class="p-col" style="margin-top: 2.2rem">
                <AutoComplete
                  placeholder="Pilih tipe"
                  id="type"
                  :dropdown="true"
                  :multiple="false"
                  v-model="selectedType"
                  :suggestions="autoFiltered"
                  @complete="searchType($event)"
                  field="name"
                />
              </div>
              <div class="p-col" style="margin-top: 2.2rem">
                <Button
                  label="Cari"
                  class="p-button-primary"
                  icon="pi pi-search"
                  @click="getAccumulationsellFilter()"
                />
              </div>
              <div
                class="p-col"
                style="margin-top: 2.2rem"
                v-if="items != null"
              >
                <router-link
                  :to="{
                    name: 'print-accumulation-selling',
                    query: {
                      start_date: start_date,
                      end_date: end_date,
                      best_seller: best_seller,
                      outlet_id: user.outlet_id
                    }
                  }"
                  target="_blank"
                >
                  <Button
                    label="Print"
                    icon="pi pi-print"
                    class="p-button-success"
                  />
                </router-link>
              </div>
            </div>
          </template>
          <template #empty>Data tidak ditemukan.</template>
          <template #loading>Mengambil data barang. Mohon tunggu</template>

          <Column
            header="Kode Label"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.code }}
              </div>
            </template>
          </Column>
          <Column header="Nama" headerStyle="text-align: center; width: 10rem">
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.name }}
              </div>
            </template>
          </Column>
          <Column
            header="Kelompok Barang"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.cat_code }}
              </div>
            </template>
          </Column>
          <Column
            header="Harga Jual (RP)"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.price | currency }}
              </div>
            </template>
          </Column>
          <Column
            header="Stok Barang"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.stock | number }}
              </div>
            </template>
          </Column>
          <Column
            header="Jumlah Terjual"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.total_sell | number }}
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
let moment = require('moment')
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  data() {
    return {
      moment: moment,
      loading: true,
      expandedRows: [],
      items: null,
      today: new Date().toISOString().split('T')[0],
      aMonthBefore: new Date(new Date().setDate(new Date().getDate() - 30))
        .toISOString()
        .split('T')[0],
      start_date: null,
      end_date: null,
      selectedType: 'Best Seller',
      selectedTypes: [
        { id: 1, code: 'Best Seller', name: 'Best Seller' },
        { id: 2, code: 'Worst Seller', name: 'Worst Seller' }
      ],
      autoFiltered: [],
      best_seller: null
    }
  },
  mounted() {
    this.getAuthUser()
    this.getAccumulationsell()
  },

  methods: {
    getAuthUser() {
      this.start_date = this.aMonthBefore
      this.end_date = this.today
    },
    searchType(event) {
      this.autoFiltered = this.selectedTypes.filter(item => {
        return (
          item.name.toLowerCase().startsWith(event.query.toLowerCase()) ||
          item.code.toLowerCase().startsWith(event.query.toLowerCase())
        )
      })
    },

    getAccumulationsell() {
      if (this.selectedType.code == 'Worst Seller') {
        this.best_seller = false
      } else {
        this.best_seller = true
      }

      let start_date = this.start_date
        ? moment(this.start_date).format('YYYY-MM-DD')
        : this.today
      let end_date = this.end_date
        ? moment(this.end_date).format('YYYY-MM-DD')
        : this.aMonthBefore

      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/outlet-items/report-sold-items?start_date=${start_date}&end_date=${end_date}&best_seller=${this.best_seller}`
        )
        .then(response => {
          if (response.status === 200) {
            this.loading = false
            this.items = response.data.data.items
          } else {
            this.loading = false
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Gagal mengambil data',
              life: 3000
            })
          }
        })
    },

    getAccumulationsellFilter() {
      this.loading = true
      if (this.end_date < this.start_date) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Gagal mengambil data',
          life: 3000
        })
        this.loading = false
        this.start_date = this.today
        this.end_date = this.today
      } else {
        this.getAccumulationsell()
      }
    },
    closeDialog() {
      this.confirmDialog = false
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.qty {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 50px;
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
